import { X } from 'lucide-react';
import styles from './MobileMenu.module.css';

const MobileMenu = ({ isOpen, onClose }) => {
  return (
    <div className={`${styles.overlay} ${isOpen ? styles.visible : ''}`}>
      <div className={`${styles.menuContainer} ${isOpen ? styles.open : ''}`}>
        <button 
          onClick={onClose}
          className={styles.closeButton}
        >
          <X size={24} />
        </button>
        <nav className={styles.mobileNav}>
          <ul>
            <li><a href="#vision" onClick={onClose}>Vision</a></li>
            <li><a href="#work" onClick={onClose}>Work</a></li>
            <li><a href="#why" onClick={onClose}>Why</a></li>
            <li><a href="#team" onClick={onClose}>Team</a></li>
            <li><a href="#journey" onClick={onClose}>Journey</a></li>
            <li><a href="#contact" onClick={onClose}>Contact</a></li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;